export enum AssessmentType {
    AUTOMATIC = 'AUTOMATIC',
    SEMI_AUTOMATIC = 'SEMI_AUTOMATIC',
    MANUAL = 'MANUAL',
    AUTOMATIC_ATHENA = 'AUTOMATIC_ATHENA',
}
